import { useState, useEffect } from 'react';
import { offlineManager } from '../utils/pwa/offline-manager';

export function useOfflineSupport() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [hasOfflineData, setHasOfflineData] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check for offline data on mount
    setHasOfflineData(offlineManager.hasOfflineData());

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const storeDataForOffline = async (data: any[]) => {
    await offlineManager.storeOfflineData(data);
    setHasOfflineData(true);
  };

  const getOfflineData = () => {
    return offlineManager.getOfflineData();
  };

  return {
    isOnline,
    hasOfflineData,
    storeDataForOffline,
    getOfflineData
  };
}